'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import {Row, Col} from 'react-flexindex-grid'


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _BenchmarkGridTable = require('./BenchmarkGridTable.css');

var _BenchmarkGridTable2 = _interopRequireDefault(_BenchmarkGridTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BenchmarkGridTable = (_dec = (0, _reactCssModules2.default)(_BenchmarkGridTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BenchmarkGridTable, _Component);

  function BenchmarkGridTable(props) {
    (0, _classCallCheck3.default)(this, BenchmarkGridTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BenchmarkGridTable.__proto__ || (0, _getPrototypeOf2.default)(BenchmarkGridTable)).call(this, props));

    _this.sortBenchmarks = function (gradeField) {
      var indxs = {
        'S&P 500': 0,
        'Russell 1000': 1,
        'Russell 2000': 2,
        'Russell 3000': 3,
        'S&P 100': 4,
        'Russell Top 200': 5,
        'MSCI ACWI': 6,
        'MSCI EAFE': 7,
        'MSCI Emerging Markets': 8,
        'MSCI ACWI ex U.S.': 9
      };
      var sorted = Array.apply(null, Array(10)).map(function (x, i) {
        return null;
      });
      var benchmarks = [].concat(_config2.default.coreBenchmarks.concat(_config2.default.extendedBenchmarks));

      for (var i = 0; i < benchmarks.length; i++) {
        if (indxs.hasOwnProperty(benchmarks[i].index_name)) {
          sorted[indxs[benchmarks[i].index_name]] = benchmarks[i];
        }
      }
      return sorted;
    };

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(BenchmarkGridTable, [{
    key: 'render',

    //
    value: function render() {
      var _this2 = this;

      var sortedBenchmarks = this.sortBenchmarks(this.props.gradeField);
      //
      return _react2.default.createElement(
        'table',
        { styleName: 'index-table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              'Index'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Rated as'
            ),
            _react2.default.createElement(
              'th',
              null,
              this.props.gradeName.charAt(0).toUpperCase() + this.props.gradeName.slice(1),
              ' grade'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          sortedBenchmarks.map(function (b, i) {
            var sName = _format2.default.sanitize(b.fund_legal_name);
            var sTicker = b.ticker || 'N';
            var url = _config2.default.routes.fund + '/' + sName + '/' + sTicker + '/' + _config2.default.profilePath + '/' + b.fund_id + '/' + b.investment_vehicle_id;
            var charGrade = b[_this2.props.gradeField].toString();
            var letterGrade = {
              1: 'A',
              2: 'B',
              3: 'C',
              4: 'D',
              5: 'F'
            }[b[_this2.props.gradeField]] || 'N/A';
            //
            return _react2.default.createElement(
              'tr',
              { key: i },
              _react2.default.createElement(
                'td',
                { styleName: 'index-title' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: url,
                    styleName: 'index-link',
                    title: b.fund_legal_name + ' | ' + _config2.default.app.title
                  },
                  b.index_name
                )
              ),
              _react2.default.createElement(
                'td',
                { styleName: 'index-subtitle' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: url,
                    styleName: 'index-link',
                    title: b.fund_legal_name + ' | ' + _config2.default.app.title
                  },
                  b.ticker
                )
              ),
              _react2.default.createElement(
                'td',
                { styleName: 'index-grade-wrap index-grade-wrap-' + b[_this2.props.gradeField] },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: url,
                    styleName: 'index-link',
                    title: b.fund_legal_name + ' | ' + _config2.default.app.title
                  },
                  letterGrade
                )
              )
            );
          })
        )
      );
    }
  }]);
  return BenchmarkGridTable;
}(_react.Component), _class2.propTypes = {
  gradeField: _react.PropTypes.string.isRequired,
  gradeName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = BenchmarkGridTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/BenchmarkGridTable/BenchmarkGridTable.js
// module id = 1350
// module chunks = 0